// extracted by mini-css-extract-plugin
export default {"calculationTable":"calculation-table_calculationTable__v2MPv","headerLabel":"calculation-table_headerLabel__5FOXE"};